// extracted by mini-css-extract-plugin
export default {"container":"style_container__J215d","content":"style_content__z6AJ6"};